<template>
    <div class="home-page">
        <div class="page-header">
            <div class="header-logo"> 
                <div class="logo"></div> 
                <p class="title">中医药大健康智能服务平台</p>
            </div>
        </div>
        <div class="page-info">
            <div class="info">
                <div class="info-right">
                    <div class="right-list">
                        <div class="list">
                            <ul class="level-one">
                                <li :class="[
                                    listActive==item.type?'active':'',
                                    item.type==1?'list-level1':'',
                                    item.type==2?'list-level2':'',
                                    item.type==3?'list-level3':'',
                                    item.type==4?'list-level4':'',
                                ]" 
                                    @click="list_tab(item)"
                                    @mouseenter="handleMouseEnter"
                                     @mouseleave="handleMouseLeave"

                                    v-for="item in infoList" :key="item.type">
                                    <p>{{item.value}}</p>
                                    <div class="icon-arrow animated-all tada"></div>
                                </li>
                            </ul>
                            
                        </div>
                    </div>
                    <ul class="level-two" >
                        <li class="animated" :class="[ 
                            index==0?'level1':'',
                            index==1?'level2':'',
                            index==2?'level3':'',
                            index==3?'level4':'',
                        ]"
                        v-for="(item,index) in levelTwoList" :key="index" v-html='item.value' ></li>
                    </ul>
                </div>
                <div class="info-loading">
                    <div class="loading">
                        <div class="loading-tit">欢迎登录</div>
                            <ul class="loading-type">
                                <li :class="loadingIndex==item.type?'active':''" v-for="(item,index) in loadingType" :key="index">{{item.value}} <span></span> </li>
                            </ul>
                        <div class="loading-cont">
                            <el-input placeholder="请输入用户名"  prefix-icon="el-icon-user" v-model="userName"> </el-input>
                            <el-input placeholder="请输入密码"  prefix-icon="el-icon-lock" v-model="password"> </el-input>
                        </div>
                        <div class="loading-btn">登  录</div>
                        <div class="loading-select">
                            <div>忘记密码</div>
                            <div class="register">新用户账号注册</div>
                        </div>
                        <div class="loading-other">
                            <div class="other-tit">
                                <span>其他登录方式</span>
                            </div>
                            <div class="weixin-icon"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <footerPage></footerPage>
        <!-- <div  class="footer ">
            <p class="footer-info">平台介绍 </p> 
            <p class="footer-info">单位官网 </p>
            <div class="footer-info relation">
                <div class="tit">联系我们 </div>
                <div>
                    <p>中国中医科学院中医药信息研究所 中医药大健康智能研发中心</p> 
                    <p>北京市东城区东直门内南小街16号 100700</p>
                    <p>联系电话：010-64089578</p>
                </div>
                

            </div>
        </div> -->
    </div>
</template>

<script> 
import homeData from './home_page/page_data.js'
import footerPage from './home_page/home_footer.vue'
export default {
    components: {
        footerPage
    },
    data () {
        return {

            navIndex:1,
            listActive:1,
            infoList:homeData.infoList,
            levelTwoList:[],
            headerNav:homeData.infoList,
            loadingIndex:1,
            loadingType:homeData.loadingType,
            userName:'',
            password:'',
            timer: null  

        }
    },
    mounted () {
        this.levelTwoList = this.infoList[0].children;
        this.periodic()
    },
    methods: {
        list_tab(item){
            this.listActive = item.type;
            this.levelTwoList = item.children;
        },
        periodic(){
            this.timer=setInterval(() => {
                // console.log(this.listActive)
                this.listActive++;
                if(this.listActive>4){
                    this.listActive=1; 
                } 
                this.levelTwoList = this.infoList[this.listActive-1].children;
            }, 5000);
        },
        handleMouseEnter() { 
            if (this.timer) {
                clearInterval(this.timer);
            }
        },
        handleMouseLeave() {
            this.periodic()
        }
    }
}
</script>

<style lang="less">
    @import url('../css/animated.less');
    @import url('../css/home_page.less');
    .animated {
        -webkit-animation-duration: 1s;
        animation-duration: 1s;
        -webkit-animation-duration: var(--animate-duration);
        animation-duration: var(--animate-duration);
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both
    }
</style>